import ReactGA from 'react-ga4';

export type GA_EVENT = { category: string; action: string, label?: string, value?: any };
export type GA_PAGE_VIEW = { hitType?: string, page: string, title: string }

export const gaEvent = (event: GA_EVENT, trackingId?: string) => {
    if (trackingId) {
        ReactGA.event({
            category: event.category,
            action: event.action,
            label: event.label, 
            value: event.value,
        });
    }
};

// export const gaEventWithParams = (name: string, params: any, trackingId?: string) => {
//     if (trackingId) {
//         ReactGA.event(name, params)
//     }
// }

export const gaCustomEvent = (eventName: string, eventParams: object, trackingId?: string) => {
    if (trackingId) {
        ReactGA.event(eventName, eventParams);
    }
}

export const gaPageview = (event: GA_PAGE_VIEW, trackingId?: string) => {
    if (trackingId) {
        ReactGA.send({ 
            hitType: event.hitType ?? "pageview",
            page: event.page, 
            title: event.title,
        });
    }
};
